var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "locataion-box pt-16 pt-lg-30 border-top border-color-light"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold color-point mb-6 mb-lg-12"
  }, [_vm._v(_vm._s(_vm.tit))]), _c('div', {
    staticClass: "mb-6 mb-lg-14"
  }, [_c('div', {
    staticClass: "d-flex page-text mb-2 mb-lg-4"
  }, [_c('p', {
    staticClass: "font-weight-bold min-w-40px mr-lg-8"
  }, [_vm._v(" 주소 ")]), _c('p', {
    staticClass: "color-grey",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" " + _vm._s(_vm.address) + " ")])]), _c('div', {
    staticClass: "d-flex page-text--sm"
  }, [_c('p', {
    staticClass: "font-weight-bold min-w-40px mr-lg-8"
  }, [_vm._v(" 전화 ")]), _c('a', {
    staticClass: "d-block color-grey",
    attrs: {
      "href": 'tel:' + _vm.tel,
      "data-aos": "fade-right"
    }
  }, [_vm._v(" " + _vm._s(_vm.tel) + " ")])])]), _c('div', {
    staticClass: "map",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.mapImage
    }
  }), _c('div', {
    staticClass: "link mt-2 mt-lg-0"
  }, [_c('arrow-btn', {
    attrs: {
      "tit": "지도보기",
      "color": "primary",
      "link": _vm.link,
      "type": "href"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }